import React from "react";
import reactDom from "react-dom";
import Main from "./components/main.jsx";
reactDom.render(<Main />, document.getElementById("root"));
